import React from "react";
import SEO from "../components/SEO";
import { MaskLineScroll } from "../components/Reveal";
import { BRAND } from "../lib/brand";

export default function Merch() {
  return (
    <>
      <SEO
        title="Merchandise — ProForm Paint & Body"
        description="ProForm merch drop coming soon. Follow @_pro_form_ for release announcements."
        canonical={`https://${BRAND.domain}/merch`}
      />
      <section className="pt-32 md:pt-40 pb-24">
        <div className="wrap">
          <div className="label mb-3">— Merch · 001</div>
          <h1 className="font-display uppercase text-5xl md:text-8xl leading-[0.88] tracking-tight max-w-4xl">
            <MaskLineScroll>The first</MaskLineScroll>
            <MaskLineScroll delay={0.08}>drop is <span className="text-proform-red">coming</span>.</MaskLineScroll>
          </h1>
          <p className="mt-8 text-chrome-300 max-w-2xl text-lg leading-relaxed">
            A short, considered run of ProForm apparel &amp; decals is in production. Nothing is listed here until it ships. Follow <a target="_blank" rel="noreferrer" href={BRAND.instagramUrl} className="text-proform-red hover:underline">@{BRAND.instagramHandle}</a> for the release.
          </p>

          <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-3">
            {["Tee · Rising Sun", "Tee · Built Different", "Vinyl · Sun Logo", "Cap · Embroidered"].map((n, i) => (
              <div key={n} className="relative aspect-[3/4] border border-ink-700 bg-ink-900 p-4 flex flex-col justify-between">
                <div className="label">— SKU · 0{i + 1}</div>
                <div>
                  <div className="font-display uppercase text-lg">{n}</div>
                  <div className="label text-proform-red mt-1">Coming soon</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
